//var CryptoJS = require("crypto-js");

export const setState = (key, value) => {
  try {
    const serializedState = JSON.stringify(value);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    return undefined;
  }
};

export const getState = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {}
};

// export const setState = (key, value) => {
//   try {
//     if (value) {
//       const serializedState = CryptoJS.AES.encrypt(
//         JSON.stringify(value),
//         "my-secret-key@123"
//       ).toString();
//       localStorage.setItem(key, serializedState);
//     }
//   } catch (err) {
//     return undefined;
//   }
// };

// export const getState = (key) => {
//   try {
//     const serializedState = localStorage.getItem(key);
//     if (serializedState === null) {
//       return undefined;
//     }
//     const decryptData = CryptoJS.AES.decrypt(
//       serializedState,
//       "my-secret-key@123"
//     ).toString();
//     return JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
//   } catch (err) {
//     return undefined;
//   }
// };
